/**
 * The chart that appears inside a chat reply when the analytics toggle is on.
 *
 * Small on purpose - it is a reply, not a dashboard. "View Analytics" opens the
 * same chart full size with the controls to change it.
 */
import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import SmartChart from './SmartChart';
import { inferColumnMeta, inferSpec } from '../utils/chartData';

const ChatChart = ({ rows, spec, columns }) => {
  const resolved = useMemo(() => {
    if (!Array.isArray(rows) || !rows.length) return null;
    if (spec && spec.type) return spec;
    // Replayed history has the rows but no spec, so derive the same
    // deterministic pick the server falls back to.
    return inferSpec(rows, Array.isArray(columns) && columns.length ? columns : inferColumnMeta(rows));
  }, [rows, spec, columns]);

  if (!resolved || resolved.type === 'table') return null;

  return (
    <Box
      sx={(theme) => ({
        mt: 1.5,
        p: 1.5,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.mode === 'dark'
          ? 'rgba(255,255,255,0.03)'
          : 'rgba(0,0,0,0.02)',
      })}
    >
      <SmartChart spec={resolved} rows={rows} height={resolved.type === 'kpi' ? undefined : 270} />
    </Box>
  );
};

export default ChatChart;
